import { render, staticRenderFns } from "./DiscussItem.vue?vue&type=template&id=2685b6c8&"
import script from "./DiscussItem.vue?vue&type=script&lang=js&"
export * from "./DiscussItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports